import moment from "moment";
import { FunctionComponent, useEffect, useMemo, useState } from "react";

import { StyledWidget } from "../common/components";
import { TableHeaders } from "../../../../components/table/Head";
import { UsersDTO } from "../../../../store/users/models/dto";
import { BooleanField, Table } from "../../../../components/table";
import { PrimaryButton } from "../../../../components/button";
import { processErrorFromPromise } from "../../../../store/errors/utils";
import { AllowedBlockchains } from "../../../../store/chain/models/internal";
import { useMintNFTMutation } from "../../../../store/models/users";
import { successNotificationFromPromise } from "../../../../store/notifications/utils";
import { colours } from "../../../../styles/colours";

type fieldNames = keyof {
    address: string;
    deleted: boolean;
    verified: boolean;
    nftMinted: boolean;
    chain: AllowedBlockchains;
    id: string;
};
function useHeaders(): TableHeaders<fieldNames> {

    return useMemo(
        () => [
            { name: "address", title: "Address" },
            { name: "chain", title: "Chain" },
            { name: "nftMinted", title: "Identity NFT Minted" },
            { name: "verified", title: "Verified" },
            {
                name: "id",
                title: "Actions",
            },

        ],
        []
    );
}

export const Wallets: FunctionComponent<{
    item: UsersDTO.Responses.GetSingle.T;
}> = ({ item }) => {

    const { wallets } = item;
    const headers = useHeaders();

    const [mintNFT] = useMintNFTMutation();
    const [disableButton, setDisableButton] = useState<boolean>(false);



    return (

        <StyledWidget title="Wallets">
            <Table
                data={wallets}
                head={headers}
                renderFields={{
                    nftMinted: ({ nftMinted }) => (
                        <>
                            <BooleanField
                                colour1={nftMinted ? colours.green : colours.red}
                            />
                        </>
                    ),
                    verified: ({ verified }) => (
                        <>
                            <BooleanField
                                colour1={verified ? colours.green : colours.red}
                            />
                        </>
                    ),
                    id: ({ id, verified, nftMinted }) => (
                        <>
                            {!nftMinted &&
                                <PrimaryButton fullWidth
                                    disabled={disableButton || !verified}
                                    onClick={() => {
                                        setDisableButton(true);

                                        mintNFT({ walletId: id, userId: item.userReferenceId })

                                            .unwrap()
                                            .then(
                                                successNotificationFromPromise('Idenitiy NFT minted successfully')
                                            )
                                            .catch(processErrorFromPromise
                                            ).finally(() => {
                                                setDisableButton(false);
                                            })
                                    }}>
                                    Mint Identity NFT
                                </PrimaryButton>}
                        </>
                    )
                }}
                unsortable={["address", "chain"]}
            ></Table>
        </StyledWidget>

    );
};
